
import classes from './StageDelete.module.css';
import { 
  select, 
  tree,
  hierarchy,
  linkHorizontal
 } from 'd3'; 

import React, { useRef, useEffect, useState } from 'react';

// https://www.youtube.com/watch?v=jfpV7OBptYE
// https://d3js.org/d3-hierarchy/tree

function StageDelete(props) {
  const svgRef = useRef();
  const containerRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [translate, setTranslate] = useState({x:0, y:0});
  const [showUuids, setShowUuids] = useState(true);


  useEffect(() => {
    if (containerRef.current) {
      const { width, height } = containerRef.current.getBoundingClientRect()
      setDimensions({ width: width-10, height: height-10 });
    }
    const centerY = dimensions.height / 2;
    // Calculate the translation required to center the root node
    const translateY = centerY;
    let posx = 0
    if (showUuids){
      posx = 180;
    }
    else {
      posx = 100
    }
    setTranslate({ x: posx, y: translateY+10} );
    // If 'hide uuid' 
    // setTranslate({ x: 100, y: translateY+10} );


  },[window.innerWidth, window.innerHeight, props.listenTo, showUuids] );




  // const data2 = {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'Project', children: [{uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'OptimizationCampaign', 
  // children: [{uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'ExperimentalSetup', children: []}, 
  // {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'DesignSpace', children: []}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'Objective', children: []}]}, 
  // {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'OptimizationCampaign', children: []}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'OptimizationCampaign', 
  // children: [{uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'ExperimentalSetup', children: []}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'DesignSpace',
  //  children: []}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'Objective', children: []}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'MLModel', children:
  //   [{uuid: 'tc0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'TrainingData', children: [{uuid: 'cc0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'CSVFile', children: 
  //   [{uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'RawDataFile', children: []}]}, {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'CSVFile', children: []}, 
  //   {uuid: 'c0c830526-16ec-4557-894f-d145d640ef5e', object_type: 'CSVFile', children: []}]}]}]}]} 



  useEffect(() => {

    const data = props.tree
    const svg = select(svgRef.current);
    // if previous elements in svg -> clean first before adding stuff
    select('svg').selectAll('*').remove();

    const treeLayout = tree()
      .nodeSize([35,190]);

    // group
    const g = svg
      // .attr('width', dimensions.width)
      // .attr('height', dimensions.height)
    .append('g')
      .attr('transform', `translate(${translate.x}, ${0})`);

    const root = hierarchy(data);
    const links = treeLayout(root).links();
    const nodes = root.descendants();

    g.selectAll('path').data(links)
      .enter().append('path')
      .attr('class', classes.my_link)
      // .attr('fill', 'none')
      // .attr('stroke', '#ccc')
      .attr('d', linkHorizontal() // Use linkVertical instead of linkHorizontal
        .x(d => d.y) 
        .y(d => d.x));

    const node = g.selectAll('.node')
        .data(nodes)
        .enter()
        .append('g')
        .attr('class', classes.my_node)
        .attr('transform', d => `translate(${d.y}, ${d.x})`);
  
      node.append('circle')
        .attr('r', 10)
        .attr('class', 'my_node');

      node.append('text')
        .attr('dy', 3)
        .attr('x',  -12)
        .style('text-anchor', 'end')
        .attr('class', classes.my_text)
        .text(d => d.data.object_type);

      if(showUuids === true) {
      node.append('text')
        .attr('dy', 15)
        .attr('x',  -12)
        .style('text-anchor', 'end')
        .style('fill', 'var(--aixelo-gray-dark')
        .attr('class', classes.my_text_uuid)
        .text(d => d.data.uuid);
      }


        const bbox = svg.node().getBBox();
        let recenter = 0
        if (dimensions.height - bbox.height > 0){
          recenter = (dimensions.height - bbox.height)/2;
        }
        svg
          .attr('width', bbox.width+100)
          .attr('height', bbox.height+recenter)
          g
            // .attr('transform', `translate(${translate.x}, ${bbox.height-dimensions.height+translate.y/2})`);
            .attr('transform', `translate(${translate.x}, ${-bbox.y+recenter})`);


  }, [dimensions, props.tree, translate, showUuids ]);


  function handleUuids(){
    if (showUuids){
      translate.x = 100;
      setTranslate(translate);
    }
    if (!showUuids){
      translate.x = 180;
      setTranslate(translate);
    }
    setShowUuids(!showUuids)
  }

  let button_name = 'hide uuids'
  if (!showUuids){
    button_name = 'show uuids'
  }

  return (
    <>
      <div className={classes.tree_canvas} style={{paddingBottom:'20px'}}>
        <button className={classes.toggle_uuid_button} onClick={handleUuids}>{button_name}</button>
        <div ref={containerRef} style={{paddingTop:'10px'}}>
          <svg ref={svgRef} style={{position:'relative'}}></svg>
        </div>
      </div>
    </>
  );
}

  


export default StageDelete